export enum TypeEnum {
    Local = 'Local',
    Imported = 'Imported',
}

export const TypeEnumDisplay = [
    { name: "Local", displayVal:'Local'},
    { name:'Imported', displayVal:'Imported'},
]

